import { AuthClient } from '@supabase/auth-js';

// The site only uses Supabase Auth (all data goes through our API), so this
// is the auth client alone instead of the full supabase-js bundle. The
// options match what createClient() used, including the storage key, so
// existing sign-ins carry over.
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.');
}

const base = new URL(supabaseUrl);

export const supabase = {
  auth: new AuthClient({
    url: new URL('auth/v1', base).href,
    headers: { Authorization: `Bearer ${supabaseAnonKey}`, apikey: supabaseAnonKey },
    storageKey: `sb-${base.hostname.split('.')[0]}-auth-token`,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'implicit',
  }),
};
